import axios from './_nestAxios'

export const getTransportistasPorFiltro = ({ busqueda }) => axios.get('/kardex/transportistas-asociados', { params: { busqueda } })

export const getDetalles_ParaVenta = ids => axios.post('/kardex/guias-ventas/info-para-ventas', { ids })

export const getGuia = _id => axios.get(`/kardex/${_id}`, { params: { tipoConsulta: 'guias-ventas' } })

export const getGuias_ParaVenta = idSocio => axios.get('/kardex', { params: { tipoConsulta: 'guias-para-facturacion', idSocio: idSocio } })

export const actualizarGuia = (_id, data) => axios.put(`/kardex/guias-ventas/${_id}`, data)

export const nuevaGuia = data => axios.post('/kardex/guias-ventas', data)

export const eliminarGuia = _id => axios.delete(`/kardex/${_id}`)

export const enviarDocumentoASunat = _id => axios.post(`/kardex/guias-ventas/${_id}/enviar-documento`)

export const descargarPdfGuia = id => axios.get(`/kardex/${id}/descargar/pdfGuiaVenta`, { responseType: 'blob' })

export const descargarPdfTicketxId = id => axios.get(`/kardex/descargar/${id}/ticket`, { responseType: 'blob' })

export const verDetallesConsultaGuias = (_id, anio) => axios.get(`/kardex/${_id}`, { params: { tipoConsulta: 'detalles-guia', anio: anio } })

export const obtenerResumenMovimientoxIdTurnoAsInfoVista = ({ self, idTurno, tipoDocumentoSunat }) =>
  axios.get('/kardex/guias-ventas/resumen-x-turno', { params: { self, idTurno, tipoDocumentoSunat } })
